import React from 'react';
import AgendamentosSetorial from '../AgendamentosSetorial';

export default function AgendamentoOdontologia() {
  return <AgendamentosSetorial setor="odontologia" />;
}
